import Vue from "vue";
import App from "./App.vue";
// import VueApexCharts from "vue-apexcharts";
// Vue.use(VueApexCharts);
// Vue.component("apexchart", VueApexCharts);

Vue.config.productionTip = false;

Vue.filter("pretty", function (value) {
  let raw = value.toFixed(0);
  let num = new Intl.NumberFormat().format(raw);
  return num;
});

new Vue({
  render: (h) => h(App),
}).$mount("#app");
